import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

interface AboutSectionProps {
  description: string
  highlights: string[]
}

export function AboutSection({ description, highlights }: AboutSectionProps) {
  const { t } = useTranslation()
  
  return (
    <div>
      <h3 className="text-2xl font-bold text-foreground mb-6">{t('tour.about')}</h3>
      <p className="text-muted-foreground leading-relaxed mb-6">
        {description}
      </p>
      
      <h4 className="text-xl font-semibold text-foreground mb-4">{t('tour.highlights')}</h4>
      <ul className="space-y-2">
        {highlights.map((highlight, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-start gap-3"
          >
            <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
            <span className="text-muted-foreground">{highlight}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  )
}
